import { render } from "./ContentL.vue?vue&type=template&id=3df7e579&scoped=true"
import script from "./ContentL.vue?vue&type=script&lang=js"
export * from "./ContentL.vue?vue&type=script&lang=js"

import "./ContentL.vue?vue&type=style&index=0&id=3df7e579&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df7e579"]])

export default __exports__